export default __webpack_public_path__ + "static/media/logo.3babf10f.jpg";